module.exports = __webpack_public_path__ + "static/media/filios-sazeides-lg3TETZvqv4-unsplash.16ef14e0.jpg";